<template>
  <div>
    <b-modal
      id="existingAttractionOptions"
      modal-class="modal-cover"
      v-model="isVisible"
      hide-backdrop
      hide-footer
      content-class="shadow-lg modal-lg"
      centered
      :dir="isHebrew ? 'rtl' : 'ltr'"
    >
      <section class="text-center">
        <b-row>
          <b-col cols="12" class="py-4">
            <h3 class="font-weight-bold title-text">
              {{ t('existingAttractionOptionsTitle') }}
            </h3>
          </b-col>

          <b-col cols="12" class="py-4">
            <b-btn
              pill
              variant="primary"
              class="action-button mb-3"
              @click="viewExisting"
            >{{ t('existingAttractionOptionsViewExisting') }}</b-btn>

            <b-btn
              pill
              variant="secondary"
              class="action-button"
              @click="createAnyway"
            >{{ t('existingAttractionOptionsCreateAnyway') }}</b-btn>
          </b-col>
        </b-row>
      </section>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { router } from '../../main';
import { translationMixin } from "@/mixins/translationMixin";

export default {
  mixins: [translationMixin],
  props: ["value"],
  computed: {
    ...mapGetters(['allRide', 'inerModalParameters', 'isUserManager', 'compareToUserId', 'rideIsWhiteLabel']),
    isVisible: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: { 
    ...mapActions([ 'showModal',
                    'fetchSerchAttractionsFromRideMangerAcount',
                    'fetchSerchAttractionsByRide'
                    ]),
    createAnyway() {
      this.showModal('');
    },
    viewExisting() {
      if (this.inerModalParameters?.lat && this.inerModalParameters?.lng) {
        this.$store.commit('setSerchLat', this.inerModalParameters.lat);
        this.$store.commit('setSerchLng', this.inerModalParameters.lng);
        // Store the day index and planned date if provided
        if (this.inerModalParameters?.dayIndex !== undefined) {
          this.$store.commit('setSerchDayIndex', this.inerModalParameters.dayIndex);
        }
        if (this.inerModalParameters?.plannedDate) {
          this.$store.commit('setSerchPlannedDate', this.inerModalParameters.plannedDate);
        }
        
        // call the right attraction
        if(this.isUserManager && this.compareToUserId(this.allRide.ride.authorId)){
          this.fetchSerchAttractionsFromRideMangerAcount();
        }
        else if(this.rideIsWhiteLabel && this.compareToUserId(this.allRide.ride.authorId)){
          this.fetchSerchAttractionsFromRideMangerAcount();
        }
        else{
          this.fetchSerchAttractionsByRide();
        }
      }
      this.showModal('');
      router.push('/serch_attractions_with_map');
    }
  },
};
</script>

<style scoped>
.modal.modal-cover .modal-content,
.modal.modal-cover .modal-footer,
.modal.modal-cover .modal-header {
  border: none;
}

.title-text {
  font-size: 24px;
  color: #2E2E3A;
  margin-bottom: 20px;
}

.action-button {
  font-size: 18px;
  padding: 15px 30px;
  width: 80%;
  max-width: 500px;
  display: block;
  margin: 0 auto;
}

.action-button:hover {
  transform: translateY(-2px);
  transition: transform 0.2s ease;
}

.modal-lg {
  max-width: 600px;
}
</style> 